import React, { useEffect } from 'react';

const DeleteConfirmation = ({ 
  show, 
  onHide, 
  onConfirm, 
  title = "Confirm Delete", 
  message = "Are you sure you want to delete this item? This action cannot be undone.",
  itemName = "",
  isDeleting = false 
}) => {
  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
      // Scroll to top of modal overlay
      setTimeout(() => {
        const overlay = document.querySelector('.admin-crud-modal-overlay');
        if (overlay) {
          overlay.scrollTop = 0;
        }
      }, 10);
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [show]);

  if (!show) return null;

  const formattedMessage = itemName 
    ? `Are you sure you want to delete "${itemName}"? This action cannot be undone.`
    : message;

  return (
    <div className="admin-crud-modal-overlay" onClick={onHide}>
      <div 
        className="admin-crud-modal admin-crud-modal-sm admin-crud-modal-delete" 
        onClick={(e) => e.stopPropagation()}
      >
        <div className="admin-crud-modal-header">
          <h4 className="admin-crud-modal-title">
            <span>⚠️</span> {title}
          </h4>
          <button className="admin-crud-modal-close" onClick={onHide}>
            ✕
          </button>
        </div>
        <div className="admin-crud-modal-body">
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            {/* Warning Icon */}
            <div style={{ 
              fontSize: '64px', 
              marginBottom: '16px',
              display: 'inline-block',
              animation: 'shake 0.5s ease'
            }}>
              🗑️
            </div>
            {/* Message */}
            <p style={{ 
              fontSize: '16px', 
              marginBottom: '16px', 
              color: '#475569',
              lineHeight: '1.5'
            }}>
              {formattedMessage}
            </p>
            {/* Additional warning for important items */}
            <p style={{ 
              fontSize: '12px', 
              color: '#94a3b8',
              marginTop: '8px'
            }}>
              This action cannot be undone.
            </p>
          </div>
        </div>
        <div className="admin-crud-modal-footer">
          <button 
            className="admin-crud-btn admin-crud-btn-secondary" 
            onClick={onHide} 
            disabled={isDeleting}
          >
            Cancel
          </button>
          <button 
            className="admin-crud-btn admin-crud-btn-danger" 
            onClick={onConfirm} 
            disabled={isDeleting}
            style={{ minWidth: '80px' }}
          >
            {isDeleting ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmation;